
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicalsoftwarequotes/privacy-policy",
      function () {
        return require("private-next-pages/medicalsoftwarequotes/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicalsoftwarequotes/privacy-policy"])
      });
    }
  